import { Calculate } from "@mui/icons-material";
import { Button } from "antd";
import { Link } from "react-router-dom";
import { useModals } from "../common/useModal";
import { FormActions } from "../../components/common/FormActions";
import {
  createRequestRequisitionAction,
  createViewAction,
  formatDateTime,
  numberFormat,
} from "../../utils/helpers";
import { URL_STAFF_WAGES, URL_WEEKLY_COMMISSION } from "../../utils/urls";

const useStaffWages = () => {
  const { openCalculateWage } = useModals();

  const tableColumns = () => [
    {
      id: "reference_number",
      header: "Reference Number",
    },
    {
      id: "staff_type_name",
      header: "Staff Type",
      filter: {
        type: "text",
      },
    },
    {
      id: "total_amount",
      header: "Total Amount",
    },
    {
      id: "generated_at",
      header: "Generated At",
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        reference_number: (
          <div className="flex gap-2">
            <Link
              className="link-with-icon"
              to={URL_WEEKLY_COMMISSION}
              state={{
                weekly_reference: item?.id,
                staff_type: item?.staff_type,
              }}
            >
              {item?.reference_number}
            </Link>
          </div>
        ),
        staff_type_name: item?.staff_type_name,
        total_amount: numberFormat(item?.total_amount),
        generated_at: formatDateTime(item?.date_generated),
        actions: (
          <FormActions
            actions={[
              createViewAction(URL_STAFF_WAGES, item?.id),
              createRequestRequisitionAction(
                item?.reference_number,
                item?.staff_type,
                item?.total_amount,
              ),
            ]}
          />
        ),
      };
    }),
  ];
  const tableHeaderItem = (
    <Button
      type="primary"
      icon={<Calculate fontSize="small" />}
      onClick={() => openCalculateWage()}
    >
      Calculate Wages
    </Button>
  );

  const wageHistory = true;
  const activityFilter = "staff";

  return {
    tableColumns,
    activityFilter,
    tableData,
    tableHeaderItem,
    wageHistory,
  };
};

export default useStaffWages;
